import { BackFromEditorButton } from 'components/common/BackFromEditorButton'
import { ErrorContext } from 'context/error/ErrorContext'
import { useContext, useState } from 'react'
import { Create, useTranslate } from 'react-admin'

import RetailerRepresentativeForm from './RetailerRepresentativeForm'

const RetailerRepresentativeCreate = (props) => {
    const translate = useTranslate()
    const [isPristineForm, setIsPristineForm] = useState(true)
    const { setErrorState } = useContext(ErrorContext)

    const handleError = (error: any) => {
        const storedValidationErrors = window.__lastGraphQLValidationError
        const graphQLError = error?.graphQLErrors?.[0] || error
        const validationErrors = graphQLError?.extensions?.validation || storedValidationErrors

        if (validationErrors) {
            const firstError = Object.values(validationErrors)[0]
            const errorMessage = Array.isArray(firstError) ? firstError[0] : firstError

            setErrorState({
                hasError: true,
                message: errorMessage as string
            })

            window.__lastGraphQLValidationError = undefined
        } else {
            setErrorState({
                hasError: true,
                message:
                    graphQLError?.message ||
                    error?.message ||
                    'An error occurred while creating the retailer representative.'
            })
        }
    }

    return (
        <>
            <BackFromEditorButton
                isPristineForm={isPristineForm}
                backToRouteURL="/retailerRepresentative"
            />
            <Create
                title={translate('manager.resources.contactPersons.create')}
                mutationOptions={{ onError: handleError }}
                {...props}
            >
                <RetailerRepresentativeForm
                    isPristineForm={isPristineForm}
                    setIsPristineFormCallback={setIsPristineForm}
                />
            </Create>
        </>
    )
}

export default RetailerRepresentativeCreate
